// extracted by mini-css-extract-plugin
export default {"card":"LuckyCard_card__isHM+","dateContainer":"LuckyCard_dateContainer__4X0Um","text":"LuckyCard_text__rAtcx"};